<template>
  <div class="table-list">
      <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%">
        <template v-for="(col,index) in cols" >
          <el-table-column v-if="col.prop!=='versions'" :key="index"
           :prop="col.prop" :label="col.label" align="center" :formatter="formatter" :min-width="col.width" show-overflow-tooltip>
          </el-table-column>
          <el-table-column  v-if="type==='process'&&col.prop==='versions'" :key="index"
            :prop="col.prop" :label="col.label" align="center" :min-width="col.width">
             <template slot-scope="scope" >
              <el-select v-model="scope.row.currentProcessId" placeholder="请选择" @change="changeVersion(scope.row)">
                <el-option
                  v-for="item in scope.row.versions"
                  :key="item.id"
                  :label="item.version"
                  :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </template>
          <el-table-column
           fixed="right" label="操作" align="center" width="180px">
            <template slot-scope="scope">
              <el-button v-if="type!=='management'" type="text" @click="viewRow(scope.row)">数据</el-button>
              <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
              <el-button type="text" @click="delRow(scope.row)">删除</el-button>
              <el-button v-if="type==='management'" type="text" @click="dataImport(scope.row)">导入</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </el-footer>
  </div>

</template>

<script>
import moment from 'moment'
export default {
  name: 'table-list',
  props: ['items', 'loading', 'cols', 'pagination', 'options', 'type'],
  watch: {
    'pagination.currentPage' (val) {
      this.$emit('changePagination', this.pagination)
    },
    'pagination.pageSize' (val) {
      this.$emit('changePagination', this.pagination)
    }
  },
  methods: {
    changeVersion (def) {
      this.$axios.get('/process-api/processes/switchCurrentVersion?',
        {params: {definitionId: def.id, currentVersionId: def.currentProcessId}})
    },
    formatter (row, column) {
      var data = row[column.property]
      // 判断是不是日期
      if (column.property === 'createTime' || column.property === 'lastModifiedDate') {
        return data && moment(data).format('YYYY-MM-DD HH:mm:ss')
      }
      if (column.property === 'publish') {
        return column.property ? '是' : '否'
      }
      // 报表的分类特殊处理
      if (this.type === 'report' && column.property === 'category') {
        let category = this.options.find(item => item.id === data)
        return category ? category.name : '默认分类'
      }
      // 表单和报表的版本
      if (this.type !== 'process' && column.property === 'version') {
        return '1'
      }
      return data
    },
    editRow (row) {
      this.$emit('editRow', row)
    },
    delRow (row) {
      this.$emit('delRow', row)
    },
    dataImport (row) {
      this.$emit('dataImport', row)
    },
    viewRow (row) {
      this.$emit('viewRow', row)
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    }
  }
}
</script>

<style lang="scss">
.table-list {
  height: 100%;
  .el-table__row .cell .el-select{
    .el-input {
      width: 90px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/data/table-list.vue